module.exports = __webpack_public_path__ + "img/icon_map_9.530f7c57.png";